export { GieliCoordinates } from "./GieliCoordinates";
export { TileCoordinates } from "./TileCoordinates";
export { TileRectangle } from "./TileRectangle";
export var floor_t;
(function (floor_t) {
    floor_t.all = [0, 1, 2, 3];
    function clamp(n) {
        return Math.max(0, Math.min(3, n));
    }
    floor_t.clamp = clamp;
})(floor_t || (floor_t = {}));
